// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { AuthWatcherFooterComponent } from './components/footer/auth-watcher-footer.component';
import {
  Illustration,
  ModalComponent,
  ParagraphComponent,
  TitleComponent,
} from '@openbank/ziniaweb-ui-components';
// Constants
import {
  AUTH_WATCHER_ILLUSTRATION_COMPONENT_PROPS,
  AUTH_WATCHER_MODAL_COMPONENT_PROPS,
  AUTH_WATCHER_MODAL_ILLUSTRATIONS,
  AUTH_WATCHER_MODAL_TITLE_COMPONENT_PROPS,
} from './constants/auth-watcher.constants';
// Hooks
import { useAuthWatcherHook } from 'providers/auth-watcher/hooks/auth-watcher.hook';
// Styles
import { AuthWatcherProviderStyled } from './auth-watcher.provider.styled';
// Types
import type { ReactChildrenType } from '@openbank/ziniaweb-ui-core-models';
// Translations
import {
  AUTH_WATCHER_DESCRIPTIONS,
  AUTH_WATCHER_TITLE,
} from './translations/auth-watcher.translations';

const AuthWatcherProvider = ({ children }: ReactChildrenType): React.ReactNode => {
  const { authConflict, ...restHook } = useAuthWatcherHook();

  return (
    <>
      {authConflict && (
        <ModalComponent
          {...AUTH_WATCHER_MODAL_COMPONENT_PROPS}
          content={
            <AuthWatcherProviderStyled>
              <Illustration
                {...AUTH_WATCHER_ILLUSTRATION_COMPONENT_PROPS}
                illustration={AUTH_WATCHER_MODAL_ILLUSTRATIONS[authConflict]}
              />
              <ParagraphComponent>
                <FormattedMessage id={AUTH_WATCHER_DESCRIPTIONS[authConflict]} />
              </ParagraphComponent>
            </AuthWatcherProviderStyled>
          }
          footer={<AuthWatcherFooterComponent {...{ authConflict, ...restHook }} />}
          title={{
            content: (
              <TitleComponent
                {...AUTH_WATCHER_MODAL_TITLE_COMPONENT_PROPS}
                title={<FormattedMessage id={AUTH_WATCHER_TITLE} />}
              />
            ),
          }}
        />
      )}
      {children}
    </>
  );
};

export { AuthWatcherProvider };
